'use client';

import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

export function ThemeConfigurator() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const handleToggle = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  // Avoid hydration mismatch: render a neutral button until mounted.
  const isLight = mounted && theme === 'light';

  return (
    <button className="switcher__btn shadow-box" onClick={handleToggle} aria-label="Toggle theme">
      <i className={isLight ? 'iconoir-light-bulb-off' : 'iconoir-light-bulb'} />
    </button>
  );
}
